import React from 'react';

import { Heading, Text, className } from 'aplazame-design-system';

import style from './style.module.scss';

export default function TestimonialComponent({
    name,
    quote,
    testimonialPosition,
}) {
    return (
        <div {...className('pr-lg-3')}>
            <Text tag="span" className={`${style.position} ${style.date}`}>
                {testimonialPosition}
            </Text>
            <Heading tag="h5" className={style.name}>
                {name}
            </Heading>
            <Text tag="blockquote" className={`body mb-0 ${style.body}`}>
                {quote}
            </Text>
        </div>
    );
}
